// window.cateData.isShowLoading = true; //页面需要loading加载数据
var campaignPagePowerFlexModule = {

    vm: function () {
        new Vue({
            el: '#vm',
            directives: {

            },
            data: {
                isCollapse : false,
                tabId:4,
                tabList:[
                    {
                        id: 4,
                        name: '最新热点',
                        isOpen:true,
                        isNewTag:true,
                        isActive:true
                    },
                    {
                        id: 1,
                        name: '概述课程',
                        isOpen:true,
                        isNewTag:false,
                        isActive:true
                    },
                    // {
                    //     id: 2,
                    //     name: '大师课程',
                    //     isOpen:false,
                    //     isActive:false
                    // },
                    {
                        id:3,
                        name: '动手演示',
                        isOpen:false, // todo 有资源上线后改为true
                        isNewTag:false,
                        isActive:false // todo 有资源上线后改为true
                    }
                ]
            },
            created: function () {
            },
            mounted: function () {
                //播放顶部banner视频
                $('.menu-list').hide()
                this.$nextTick(function(){
                    this.$refs.bannerVideo.muted = false;
                    this.$refs.bannerVideo.play();
                });
                if (window.location.href.indexOf('?')!= -1){
                    if (getUrlPara('tab') == 3) {
                        this.tabId = 3;
                    }else if (getUrlPara('tab') == 1) {
                        this.tabId = 1;
                    }else {
                        this.tabId = 4;
                    }
                }
            },
            watch: {
                tabId: function (curVal, oldVal) {
                    if (curVal !== oldVal) {
                        campaignPagePowerFlexModule.initSwiper();
                    }
                }
            },
            methods: {
                tabItemClick: function (item) {
                    if (item.id == 4 || item.id == 1) {
                        this.tabId=item.id;
                    }
                    // todo 有资源上线后放开注释
                    // if (item.id==2){
                    //     this.tabId=1;
                    // } else {
                    //     this.tabId=item.id;
                    // }
                },
                leftNavClick: function (item){
                    console.log(item)
                },
                goTop: function (){
                    document.documentElement.scrollTop = $('.top-banner-box').height() + 80;
                },

                goTopMobile:function (){
                    document.documentElement.scrollTop = 100;
                }
            }
        })
    },

    init:function () {
        this.vm();
        this.initSwiper();
    },
    /* swiper初始化 */
    initSwiper: function () {
        // 假设所有swiper容器都有swiper-container类
        var swiperContainers_pc = document.querySelectorAll('.lecturer-list-pc');
        // 遍历所有容器并初始化Swiper
        swiperContainers_pc && swiperContainers_pc.forEach(function (container) {
            var parentElement = container.parentNode; // 或者使用 closest() 方法找到最近的共同父元素

            // 现在，我们可以在parentElement内部查找product-next-swiper-btn
            var nextButton = parentElement.querySelector('.lecturer-next-swiper-btn');
            var prevButton = parentElement.querySelector('.lecturer-prev-swiper-btn');
            var mySwiper = new Swiper(container, {
                // 这里是公共配置，或者你可以根据container来动态设置配置
                loop: false,
                autoplay: false,
                spaceBetween: 55,
                slidesPerView: 3,
                breakpoints: {
                    1600: {  //当屏幕宽度小于等于1280
                        spaceBetween: 40
                    }
                },
                allowTouchMove: false, // 禁止触摸滑动
                observer:true,//修改swiper自己或子元素时，自动初始化swiper
                observeParents:true,//修改swiper的父元素时，自动初始化swiper
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
            });
        });
    },
};
campaignPagePowerFlexModule.init();
